import {stringify} from "csv-stringify/lib/sync";
import formActions from "./common-form-actions";
import docready from "../libs/docready";
import uploadCsv from "./uploadCsv";
import downloadCsv from "./downloadCsv";
import {getElementOffset, getPageOffset} from "../libs/sizes";
import MessageFormat from "messageformat";
import {attachGroupCovers} from "./image-field";

const format = new MessageFormat(document.documentElement.lang)

/**
 * Show modal for edit form.
 * @returns {Promise<void>}
 */
export default async function () {
    formActions.loadForm('/site/communities/edit-form', {
        cid: cid,
    }).then(modal => {
        modal.modal('show');
        modal.addClass('edit-community-modal');
        tagDrag();
    }).catch(err => {
        console.log(err)
        window.openAlert(getCommonError(), 'error')
    });
}

$(document).on('submit', '#EditCommunityForm', async function (e) {
    e.preventDefault()
    const form = $(this)
    formActions.cleanForm(form);
    spinner.show(window.translate.spinner_text_save || '');
    form.trigger('submitting.coing');
    const formData = new FormData(form[0]);
    formData.append('cid', cid);
    const groups = []

    form.find('.field-editcommunity-tags-group').each(function () {
        let title = $(this).find('input.group-name').val(),
            method = $(this).find('.group-method').val(),
            items = $(this).find('input.tag-value').map(function () {
                if (this.value) {
                    return $(this).val();
                }
            }).get();
        if (items.length > 0) {
            groups.push({
                name: title,
                method: method,
                items: items
            })
        }
    })

    if($('[name="EditCommunity[terms_and_conditions]"]').hasClass('changed')) {
        const terms_and_conditions = new Blob([formData.get('EditCommunity[terms_and_conditions]')], {type: 'text/html'})
        formData.append('terms_and_conditions_file', terms_and_conditions, 'terms_and_conditions.html')
    }
    if($('[name="EditCommunity[privacy_terms]"]').hasClass('changed')) {
        const privacy_terms = new Blob([formData.get('EditCommunity[privacy_terms]')], {type: 'text/html'})
        formData.append('privacy_terms_file', privacy_terms, 'privacy_terms.html')
    }

    formData.delete('EditCommunity[terms_and_conditions]')
    formData.delete('EditCommunity[privacy_terms]')

    const blob = new Blob([JSON.stringify(groups)], {type: 'application/json'})
    formData.append('custom_filter_groups_file', blob, 'custom_filters_groups')
    form.trigger('submitted.coing');
    Promise.all([
        attachGroupCovers(form, formData),
        ...form.find('canvas.changed').map(function() {
            // console.log( $(this));
            return new Promise (resolve => {
                $(this)[0].toBlob(blob => {
                    formData.append($(this).closest('.profile-image').data('attribute'), blob)
                    resolve()
                })
            })
        })
    ]).then(async () => {
        try {
            const data = await $.ajax({
                url: '/site/communities/update-community-settings',
                data: formData,
                processData: false,
                contentType: false,
                type: 'post',
                dataType: 'json'
            })
            if (data.success) {
                form.trigger('success.submitted.coing')
                if (data.message) {
                    await window.openAlert(data.message, 'success')
                }
                location.reload();
            } else {
                spinner.remove();
                await formActions.applyFormErrors(form, data.errors, '#editcommunity-{field}');
                window.openAlert(data.message || '', 'error');
                Object.entries(data.errors).forEach(([field, message]) => {
                    if (field === 'editcommunity-custom_filter_groups') {
                        $('.' + field).find('.form-group').each(function () {
                            if (!$(this).find('.group-name').val() || $(this).find('.tags-widget>div').length === 1) {
                                $(this).addClass('has-error');
                                $(this).find('.community-group-title').append(
                                    $('<p>').attr('id', field + '-error').addClass('help-block').addClass('help-block-error').html(message)
                                )
                            }
                        });
                    }
                });
                form.trigger('fail.submitted.coing')
                form.find('.has-error :visible:focusable:first').focus();
            }
        } catch (e) {
            window.openAlert(getCommonError(), 'error');
        }
        spinner.remove();
    })
    return false
})

$(document).on('click', '.tags-widget button.add-tag', function (e) {
    e.preventDefault()
    $(this).parent().before(
        $('<div class="tag-container draggable-tag" draggable="true">' +
            '<input type="text" class="form-control tag-value" name="' + $(this).parent().attr('data-fieldname') + '" value="' + $(this).prev().val() + '">' +
            '<button class="remove-tag">&#x2716;</button>' +
            '</div>'
        )
    )
    $('[name="new_tag_field"]').val('').focus()
})

$(document).on('click', '.clear-tags', function (e) {
    e.preventDefault()
    $(this).parent().next().find('.tag-container:not(.last)').remove();
})

$(document).on('click', '.remove-group-tag', function (e) {
    e.preventDefault()
    $(this).closest('.field-editcommunity-tags-group').remove();
    $('.community-group-title label').each(function (index) {
        $(this).find('span').text('#' + (index + 1));
    });
    $('.add_tag_group').data('number', $('.add_tag_group').data('number') + -1)
    if ($('.add_tag_group').data('number') < 3) {
        $('.add_tag_group').show();
    }
})

$(document).on('click', '.download-tags', async function (e) {
    e.preventDefault();
    const tagField = $(this).closest('.form-group');
    const content = tagField.find('input:not(.hidden)')
        .map(function() {
            return '"' + $(this).val().replace(/"/g, '"') + '"' + "\n";
        })
        .get()
        .join();
    const encodedUri = encodeURI('data:text/csv;charset=utf-8,' + content);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'tags.csv');
    document.body.appendChild(link); // Required for FF
    link.click();
    document.body.removeChild(link); 
});

$(document).on('click', '.add_tag_group', async function (e) {
    e.preventDefault();
    var groupNumber = $(this).data('number');
    try {
        const data = await $.get('/site/communities/empty-group', {groupNumber, cid})
        if (data.vars) {
            Object.entries(data.vars).forEach(function ([name, value]) {
                window[name] = value
            })
        }
        $(this).parent().before($(data.body));
        $(this).parent().parent().find("[data-tooltip]").each((i, elem)=>{
            $(elem).setTooltip();
        });
    } catch (e) {
        window.openAlert(getCommonError(), 'error')
    }
    $(this).data('number', $(this).data('number') + 1)
    if ($(this).data('number') >= 3) {
        $(this).hide();
    }
})

$(document).on('keyup', '[name="tag-group-search"]', function () {
    const filter = $(this).val()
    const container = $(this).data('container')
        ?  $($(this).data('container'))
        : $(this).closest('.tag-group-modal')
    const itemContainer = $(this).data('item') || 'li'
    container.find('a[role="checkbox"],input[type="checkbox"]').each(function () {
        if ($(this).closest(itemContainer).text().search(new RegExp(filter, "i")) < 0) {
            $(this).closest(itemContainer).removeClass('match').addClass('hidden');
        } else {
            $(this).closest(itemContainer).removeClass('hidden').addClass('match');
        }
    });

});

const setGroupOpen = function($this, open) {
    if (!$this) {
        return
    }
    if (open === undefined) {
        open = !$this.parent().hasClass('active')
    }
    if (open) {
        $this.attr('aria-expanded', 'true').focus()
        $this.attr('aria-label', 'Close ' + $this.attr('data-group'))
        // build modal
        const searchLabel = format.compile(translate.tags.search_by)
        const $em = $(`<dialog class="tag-group-modal" role="alertdialog" aria-label="${translate.tags.modal_label}">
<div class="content-wrapper"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span><svg class="svg-sprite window-close" viewBox="0 0 27 27" aria-label="Close"><title>Close</title><use xlink:href="#icon-close"></use></svg></span></button>
<div class="tag-group-search"><input type="text" class="form-control" name="tag-group-search" value="" aria-autocomplete="list" autofocus="" aria-label="${searchLabel({field: $this.attr('data-group')})}"></div>
</div>
</dialog>`)
        $this.siblings('ul').detach().appendTo($em.find('.content-wrapper'))
        $em.appendTo($this.parent());
        const em = $em[0]
        em.showModal()
        const pageOffset = getPageOffset()
        const parentOffset = getElementOffset($this.parent())
        em.style.top = parentOffset.bottom + 5 + 'px'
        if($('html').attr('dir') === 'ltr') {
            em.style.left = parentOffset.left + 'px'
            em.style.right = 'unset';
        } else {
            em.style.right = pageOffset.width - parentOffset.right + 'px'
            em.style.left = 'unset';
        }
        $(document).off('keydown.taggroup').on('keydown.taggroup', function(e) {
            if (e.key === 'Escape') {
                setGroupOpen($this, false)
                $this.focus()
            }
        })
        em.addEventListener('close', (event) => {
            $(event.target).find('ul').detach().appendTo($this.parent())
            $(event.target).remove()
        })
    } else {
        $(document).off('keydown.taggroup')
        $this.attr('aria-expanded', 'false')
        $this.attr('aria-label', 'Open ' + $this.attr('data-group'))
        $this.siblings('dialog[open]').each((i, em) => em.close())
    }
}
$(document).on('click', '.tag-group-name', function (e) {
    e.preventDefault();
    setGroupOpen($(this).parent().siblings('.tag-group.active').find('.tag-group-name'), false)
    setGroupOpen($(this))
})
    .on('keydown', '.tag-group-name', function(e) {
        console.log(e.key)
    });

$(document).on('click','.map-mobile-filters .tag-group > a',function (e){
    e.preventDefault();
    $(this).attr('aria-expanded', 'true')
    $('.tags-list-group[data-filters="'+$(this).attr('data-group')+'"]').show();
    $(this).closest('.map-mobile-filters').addClass('overlap');
    $('.map-mobile-filters .overflow').show();
    $('.mobile-tags').addClass('active').slideDown();
});

$(document).on('click','.map-mobile-filters .overflow', function (){
    $('.mobile-tags.active').slideUp();
    $(this).hide();
    $(this).closest('.map-mobile-filters').removeClass('overlap')
        .find('.tag-group [aria-expanded=true]').attr('aria-expanded', 'false')
    $('.tags-list-group').hide();
    let lists = $(".mobile-tags .tags-list");
});

$(document).on('click', '.map-mobile-filters button.close', () => $('.map-mobile-filters .overflow').trigger('click'))
$(document).on('click', '.tag-group-modal button.close', e => setGroupOpen($(e.currentTarget).closest('.tag-group').find('.tag-group-name'), false))

$(document).mouseup(function (e) {
    let container = $(".tag-group-modal .content-wrapper");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.tag-group').removeClass('active');
        $('.tag-group-modal[open]').each((i, em) => em.close())
    }
});

$(document).on('click', '.sort-tags', function (e) {
    e.preventDefault()
    var sort_by_value = function (a, b) {
        return a.firstElementChild.value.toLowerCase().localeCompare(b.firstElementChild.value.toLowerCase());
    }

    var list = $(this).parent().next().find(".tag-container:not(.last)").get();
    list.sort(sort_by_value);
    for (var i = 0; i < list.length; i++) {
        list[i].parentNode.lastElementChild.before(list[i]);
    }
})

$(document).on('click', '.tags-widget button.remove-tag', function (e) {
    e.preventDefault()
    $(this).parent().remove()
})

window.tagDrag = function () {
    let tasksListElement = document.querySelectorAll(`.draggable-tags`);
    tasksListElement.forEach(item => {
        item.addEventListener(`dragstart`, (evt) => {
            evt.target.classList.add(`selected`);
            evt.target.parentElement.classList.add(`dragging`);
        });
        item.addEventListener(`dragend`, (evt) => {
            evt.target.classList.remove(`selected`);
            evt.target.parentElement.classList.remove(`dragging`);
            let sort = 1;
            $(evt.target.parentElement).closest('form').find('input.sort').each(function () {
                $(this).val(sort);
                sort++;
            });
        });
        item.addEventListener(`dragover`, (evt) => {
            evt.preventDefault();

            const activeElement = item.querySelector(`.selected`);
            const currentElement = evt.target;
            const isMoveable = activeElement !== currentElement &&
                currentElement.classList.contains(`draggable-tag`);

            if (!isMoveable) {
                return;
            }

            const nextElement = getNextElement(evt.clientY, currentElement);

            if (
                nextElement &&
                activeElement === nextElement.previousElementSibling ||
                activeElement === nextElement
            ) {
                return;
            }

            item.insertBefore(activeElement, nextElement);
        });
    })

    const getNextElement = (cursorPosition, currentElement) => {
        const currentElementCoord = currentElement.getBoundingClientRect();
        const currentElementCenter = currentElementCoord.y + currentElementCoord.width / 2;

        const nextElement = (cursorPosition < currentElementCenter) ?
            currentElement :
            currentElement.nextElementSibling;
        return nextElement;
    };


};

$(document).on('click', '.tags-widget button.add-from-file-tag', function (e) {
    e.preventDefault();
    const input = document.createElement('input')
    input.setAttribute('type', 'file');
    this.parentElement.appendChild(input);

    $(input).on('change', function () {
        let element = $(this).parent();
        if (this.files.length > 0) {
            const file = this.files[0]
            if (file.type === 'text/csv') {
                const reader = new FileReader();
                reader.onloadend = function () {
                    let data = this.result.split("\n");
                    data.forEach(item => {
                        item = item
                            .replace(/^\"?(.+?)\"?$/, '$1')
                            .replace(/\"\"/g, '\"')
                            .replace('"', "'")
                            .trim()
                        if (item) {
                            element.before(
                                $('<div class="tag-container draggable-tag" draggable="true">' +
                                    '<input type="text" class="form-control tag-value" name="" value="' + item + '">' +
                                    '<button class="remove-tag">&#x2716;</button>' +
                                    '</div>'
                                )
                            )
                        }
                    })
                };
                reader.readAsText(file)

            }
        }
        $(this).remove();
    })
    input.click();
});

$(document).on('click', '#EditCommunityOptions .edit-option', function (e) {
    e.preventDefault();
    const option = $(this).closest('.option');
    option.addClass('editable');
});

$(document).on('click', '#EditCommunityOptions .show-option', function (e) {
    e.preventDefault();
    const option = $(this).closest('.option');
    option.removeClass('editable');
});

$(document).on('dblclick', '#EditCommunityOptions .option', function (e) {
    e.preventDefault();
    $(this).find('.edit-option').trigger('click');
});

$(document).on('submit', '#EditCommunityOptions', async function (e) {
    e.preventDefault();
    const form = $(this);
    formActions.cleanForm(form);
    spinner.show();
    const formData = new FormData(form[0]);
    formData.append('cid', cid);

    try {
        const data = await $.ajax({
            url: '/site/communities/update-community-forms',
            data: formData,
            processData: false,
            contentType: false,
            type: 'post',
            dataType: 'json'
        })
        if (data.success) {
            if (data.message) {
                window.openAlert(data.message, 'success')
            }
        } else {
            await formActions.applyFormErrors(form, data.errors, '[name="{field}"]', '.option.draggable-tag');
            if (data.message) {
                window.openAlert(data.message, 'error');
            }
        }
    } catch (e) {
        openAlert(getCommonError(), 'error');
    }
    spinner.remove();
});

$(document).on('click', '.toggle-edit-mode', function (e) {
    e.preventDefault();
    $(this).closest('form').toggleClass('editable');
});

$(document).on('click', '.tabs-controls a', function (e){
    e.preventDefault();
    if(!$(this).hasClass('.active')){
        let parentElem = $(this).closest('.tabs-controls');
        let tabsWrap = parentElem.next();
        parentElem.find('a').removeClass('active');
        $(this).addClass('active');
        tabsWrap.find('.tabs').removeClass('active');
        tabsWrap.find($(this).attr('href')).addClass('active');
    }
})


$(document).on('click', '.toggle-show-option', function (e) {
    e.preventDefault();
    if (!$(this).hasClass('disabled')) {
        const optionField = $(this).closest('.option');
        const isShow = parseInt(optionField.find('input.show').val());
        if (isShow) {
            optionField.find('input.show').val(0);
            optionField.removeClass('show');
            optionField.find('.mandatory > input[type="checkbox"]').attr('checked', false);
            optionField.find('.text-label.required').removeClass('required');
            $(this).find('i.glyphicon').removeClass('glyphicon-eye-open').addClass('glyphicon-eye-close');
        } else {
            optionField.find('input.show').val(1);
            optionField.addClass('show');
            $(this).find('i.glyphicon').removeClass('glyphicon-eye-close').addClass('glyphicon-eye-open');
        }
    }
});

$(document).on('change', '.show-admin-switcher', function (e) {
    e.preventDefault();
    const optionField = $(this).closest('.option');
    const isShow = parseInt(optionField.find('.show-admin-switcher:checked').val());
    if (isShow) {
        optionField.find('.glyphicon-star').removeClass('hidden');
    } else {
        optionField.find('.glyphicon-star').addClass('hidden');
    }
});

$(document).on('click', '.add-new-option-place__button', function (e) {
    e.preventDefault();
    $(this).closest('.add-new-option-place').toggleClass('open');
});

$(document).on('click', '.add-new-option-place__link', async function (e) {
    e.preventDefault();
    const section = $(this).data('section');
    const category = $(this).data('category');
    const type = $(this).data('type');
    if (!$(this).hasClass('disabled') && options && options[section] && options[section][category] && options[section][category][type]) {
        const keys = options[section][category][type];
        const key = keys.shift();
        if (keys.length === 0) {
            $(this).addClass('disabled');
        }
        let maxSort = 0;
        $(this).closest('form').find('input.sort').each(function () {
            if (parseInt($(this).val()) > parseInt(maxSort)) {
                maxSort = $(this).val();
            }
        });
        await spinner.show();
        try {
            maxSort++;
            const data = await $.get('/site/communities/get-option-form', { cid, key, section, index: maxSort });
            if (data.body) {
                $(this).closest('form').find(`.edit-mode .draggable-tags[data-section='${section}']`).append(data.body);
                $(this).closest('form').find('.add-new-option-place').removeClass('open');
                let sort = 1;
                $(this).closest('form').find('input.sort').each(function () {
                    $(this).val(sort);
                    sort++;
                });
                if (keys.length === 0) {
                    $(this).remove();
                }
            }
        } catch (e) {
            window.openAlert(getCommonError(), 'error');
        }
        spinner.remove();
    }
});

$(document).on('change', '.for-label', function (e) {
    $(this).closest('.option').find('.text-label').text($(this).val());
});

// edit-option-form
window.updating = false;

function addInput(field) {
    let template = field.find('input[type=\"text\"].hidden');
    let next;
    if (template.length) {
        next = $(template).clone().removeClass('hidden');
    }else {
        template = field.find('template')
        next = $(template.html())
    }
    field.append(next);
    return next;
}

$(document).on('click', '.multi-values-widget .add_value', function (e) {
    e.preventDefault();
    const valueField = $(this).closest('.edit-option-form').find('.values_content');
    addInput(valueField);
});

$(document).on('change', '.values_content input:not(.hidden)', function (e) {
    if (!window.updating) {
        const valueField = $(this).closest('.edit-option-form').find('.values_content');
        valueField.find('input.result').val(
            'json:' + JSON.stringify(valueField.find('input:not(.hidden)').map((i, el) => el.value).get())
        )
    }
})

$(document).on('click', '.upload_values', function (e) {
    e.preventDefault();
    const container = $(this).closest('.edit-option-form').find('.values_content');
    uploadCsv(
        row => addInput(container).val(row[0]),
        () => container.find('input:not(.hidden)').remove(),
        () => container.find('input:not(.hidden):first').trigger('change')
    )
});

$(document).on('click', '.download_values', function (e) {
    e.preventDefault();
    const valueField = $(this).closest('.edit-option-form').find('.values_content');
    const content = stringify(
        // [row][column]
        valueField.find('input:not(.hidden)').get().map((e) => [$(e).val()])
    )
    downloadCsv(content)
});

window.editOptions = function (type) {
    formActions.loadForm('/site/communities/edit-options', {
        cid: cid,
        type: type,
    }).then(modal => {
        modal.modal('show');
        tagDrag();
        modal.find("[data-tooltip]").each((i, elem)=>{
            $(elem).setTooltip();
        });
    }).catch(err => {
        console.log(err)
        window.openAlert(getCommonError(), 'error')
    });
}

$(document).on('click', '.map-markers-widget #add_value', function (e) {
    e.preventDefault();
    const newBlock = addMarkerInput();
    const valueField = $(this).closest('.edit-option-form').find('.values_content');
    valueField.append(newBlock);
    const fileInput = newBlock.querySelector("[type='file']");
    const colorInput = newBlock.querySelector("[name='color']");
    const iconColorInput = newBlock.querySelector("[name='icon_color']");
    fileInput.addEventListener("input", fileChange);
    colorInput.addEventListener("input", colorChange);
    iconColorInput.addEventListener("input", iconColorChange);
});

$(document).on('change', '.map-markers-widget input:not(.hidden)', changingMarkersFunction)
$(document).on('input', '.map-markers-widget [type="file"]', fileChange);
$(document).on('input', '.map-markers-widget [name="color"]', colorChange);
$(document).on('input', '.map-markers-widget [name="icon_color"]', iconColorChange);
$(document).on('click', '.map-markers-widget a.delete', removeInput);

function addMarkerInput() {
    let newElement = document.createElement("div");
    newElement.className = "marker-item";
    
    let hiddenInput = document.createElement("input");
    hiddenInput.type = "hidden";
    hiddenInput.name = "id";
    
    let inputCheckboxWrap = document.createElement("div");
    let inputCheckbox = document.createElement("input");
    inputCheckbox.type = "checkbox";
    inputCheckbox.name = "checked";
    inputCheckbox.className = "form-control";
    inputCheckboxWrap.appendChild(inputCheckbox);
    newElement.appendChild(inputCheckboxWrap);

    let inputIconWrap = document.createElement("div");
    let inputIcon = document.createElement("input");
    inputIcon.type = "hidden";
    inputIcon.name = "icon";
    inputIcon.className = "form-control";
    let inputFile = document.createElement("input");
    inputFile.type = "file";
    inputFile.name = "icon_file";
    inputFile.className = "form-control";            
    inputIconWrap.appendChild(inputIcon);
    inputIconWrap.appendChild(inputFile);
    renderDefaultSvg(inputIconWrap);
    newElement.appendChild(inputIconWrap);

    let inputLabelWrap = document.createElement("div");
    let inputLabel = document.createElement("input");
    inputLabel.type = "text";
    inputLabel.name = "label";
    inputLabel.className = "form-control";
    inputLabelWrap.appendChild(inputLabel);
    newElement.appendChild(inputLabelWrap);
    
    let inputIconColorWrap = document.createElement("div");
    let inputIconColor = document.createElement("input");
    inputIconColor.type = "color";
    inputIconColor.name = "icon_color";
    inputIconColor.value = "#d9d9d9";
    inputIconColor.className = "form-control";
    inputIconColorWrap.appendChild(inputIconColor);
    newElement.appendChild(inputIconColorWrap);

    let inputColorWrap = document.createElement("div");
    let inputColor = document.createElement("input");
    inputColor.type = "color";
    inputColor.name = "color";
    inputColor.value = "#d9d9d9";
    inputColor.className = "form-control";
    inputColorWrap.appendChild(inputColor);
    newElement.appendChild(inputColorWrap);

    let deleteButtonWrap = document.createElement("div");
    let deleteButton = document.createElement("a");
    deleteButton.href = "#";
    deleteButton.innerHTML = "<span class='glyphicon glyphicon glyphicon-trash' aria-hidden='true'></span>";
    deleteButton.className = "delete";
    deleteButtonWrap.appendChild(deleteButton);
    newElement.appendChild(deleteButtonWrap);

    return newElement;
}

function renderDefaultSvg(node) {
    let iconSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    let iconPath = document.createElementNS("http://www.w3.org/2000/svg", "path");

    iconSvg.setAttribute("fill", "none");
    iconSvg.setAttribute("viewBox", "0 0 15 20");
    iconSvg.setAttribute("width", "25");
    iconSvg.setAttribute("height", "32");
    
    iconPath.setAttribute("d", "M15 7.90757C15 12.2748 7.5 20 7.5 20C7.5 20 0 12.2748 0 7.90757C0 3.54034 3.35786 0 7.5 0C11.6421 0 15 3.54034 15 7.90757Z");
    iconPath.setAttribute("fill", "#d9d9d9");
    
    iconSvg.appendChild(iconPath);
    return node.appendChild(iconSvg);
}

function fileChange() {
    let input = $(this);
    let file = input.prop("files")[0];
    let fr = new FileReader();
    fr.onload = function () {
        let icon = fr.result;
        renderSVG(input, icon);
    };
    fr.readAsText(file);
}

function colorChange() {
    let parent = $(this).closest(".marker-item");
    parent.find("svg>path").attr("fill", this.value);
}

function iconColorChange() {
    let parent = $(this).closest(".marker-item");
    parent.find("svg>marker path").attr("fill", this.value);
}

function removeInput(e) {
    e.preventDefault();
    $(this).closest(".marker-item").remove();
    changingMarkersFunction();
}

function changingMarkersFunction(){
    if (!window.updating) {
        $(".map-markers-widget .values_content input.result").val(
            JSON.stringify($(".marker-item").map(function (i, el) {
                if(!$(this).hasClass("title-wrap")){
                    let items = {};
                    if ($(this).find("[name=\"icon_file\"]+svg")[0]) {
                        let fileContent = new XMLSerializer().serializeToString($(this).find("[name=\"icon_file\"]+svg")[0]);
                        $(this).find("[name=\"icon\"]").val(window.btoa(fileContent));
                    }
                    let marker = {}
                    $(this).find("input").each(function () {
                        switch ($(this)[0].name) {
                            case "checked":
                                marker[$(this).attr("name")] = this.checked ? true : false;
                                break;
                            case "id":
                                items["id"] = $(this).val();
                                break;
                            case "icon_file":
                                break;
                            default:
                                marker[$(this).attr("name")] = $(this)[0].value;
                                break;
                        }
                    });
                    items["option_value"] = marker;
                    return items;
                }
            }).get())
        )
    }
}

function renderSVG(input, image) {
    let parser = new DOMParser();
    let icon = parser.parseFromString(image, "text/html").body.childNodes[0];
    let viewBoxArray = icon.getAttribute("viewBox").split(" ");
    let paths = icon.getElementsByTagName("path");
    let xmlns = "http://www.w3.org/2000/svg";
    let svg = document.createElementNS(xmlns, "svg");
    let fillColor = $(input).closest(".marker-item").find("[name=\"color\"]").val();
    let id = new Date().getTime();
    let svgIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 20\" width=\"25\" height=\"32\">" +
        "<marker id=\"" + id + "\" viewBox=\"" + icon.getAttribute("viewBox") + "\" markerWidth=\"9\" markerHeight=\"9\" refX=\"" + (viewBoxArray[2] / 2) + "\" refY=\"" + (viewBoxArray[3] / 2) + "\">";
    for (let a = 0; a < paths.length; a++) {
        svgIcon += new XMLSerializer().serializeToString(paths[a]);
    }
    svgIcon += "</marker><path d=\"M15 7.90757C15 12.2748 7.5 20 7.5 20C7.5 20 0 12.2748 0 7.90757C0 3.54034 3.35786 0 7.5 0C11.6421 0 15 3.54034 15 7.90757Z\" fill=\"" + fillColor + "\"></path>" +
        "<polyline points=\"0,8 7.5,8 15,8\" stroke=\"transparent\" marker-mid=\"url(#" + id + ")\"></polyline>" +
        "</svg>";
    $(input).parent().find("svg").remove();
    $(input).parent().append(svgIcon);
    $(input).parent().find("[name=\"icon\"]").val(svgIcon);
}

//status-color-option

$(document).on('change', '#status_values_content input:not(.hidden)', changingFunction);

function changingFunction(){
    if (!window.updating) {
        $("#status_values_content input.result").val(
            JSON.stringify($(".marker-item").map(function (i, el) {
                if(!$(this).hasClass("title-wrap")){
                    let items = {};
                    let marker = {}
                    $(this).find("input").each(function () {
                        switch ($(this)[0].name) {
                            case "id":
                                items["id"] = $(this).val();
                                break;
                            default:
                                marker[$(this).attr("data-name")] = $(this)[0].value;
                                break;
                        }
                    });
                    items["option_value"] = marker;
                    return items;
                }
            }).get())
        )
    }
}

$(document).on('click', '#add_status_value', function (e) {
    e.preventDefault();
    addStatusInput();
});

$(document).on('click', '.marker-item a.delete', function (e) {
    e.preventDefault();
    $(this).closest(".marker-item").remove();
    changingFunction();
});

function addStatusInput() {
    let newElement = document.createElement("div");
    newElement.className = "marker-item";

    let hiddenInput = document.createElement("input");
    hiddenInput.type = "hidden";
    hiddenInput.name = "id";

    let inputLabelWrap = document.createElement("div");
    inputLabelWrap.className = "marker-label";
    let inputLabel = document.createElement("input");
    inputLabel.type = "text";
    inputLabel.name = "status-label";
    inputLabel.dataset.name = "label";
    inputLabel.className = "form-control";
    inputLabelWrap.appendChild(inputLabel);
    newElement.appendChild(inputLabelWrap);

    let inputColorWrap = document.createElement("div");
    inputColorWrap.className = "marker-color";
    let inputColor = document.createElement("input");
    inputColor.type = "color";
    inputColor.name = "color";
    inputColor.dataset.name = "color";
    inputColor.value = "#d9d9d9";
    inputColor.className = "form-control";
    inputColorWrap.appendChild(inputColor);
    newElement.appendChild(inputColorWrap);

    let inputRemarkWrap = document.createElement("div");
    inputRemarkWrap.className = "marker-remark";
    let inputRemark = document.createElement("input");
    inputRemark.type = "text";
    inputRemark.name = "status-remark";
    inputRemark.dataset.name = "remark";
    inputRemark.className = "form-control";
    inputRemarkWrap.appendChild(inputRemark);
    newElement.appendChild(inputRemarkWrap);

    let deleteButtonWrap = document.createElement("div");
    deleteButtonWrap.className = "marker-delete";
    let deleteButton = document.createElement("a");
    deleteButton.href = "#";
    deleteButton.innerHTML = "<span class=\"glyphicon glyphicon glyphicon-trash\" aria-hidden=\"true\"></span>";
    deleteButton.className = "delete";
    deleteButtonWrap.appendChild(deleteButton);
    newElement.appendChild(deleteButtonWrap);

    $("#status_values_content").append(newElement);
    return newElement;
}

window.duplicateCommunity = function () {
    let modal = $('#CopyCommunityModal');
    modal.modal('show');
    let formNameInput = modal.find('input[name="form-name"]');
    let errorText = modal.find('.form-name-error');
    formNameInput.on('keyup', function() {
        errorText.addClass('hidden');
    });
}

$(document).on('click', '#CopyCommunityModal .btn-main', async function (e) {
    const $modal = $('#CopyCommunityModal');
    const formNameInput = $modal.find('input[name="form-name"]');
    try {
        spinner.show();
        const response = await $.get(`/site/communities/duplicate/${cid}`, {
            name: formNameInput.val(),
        });
        const { success, message, data, errors } = response;
        window.openAlert(message, success ? 'success' : 'error');
        if (success) {
            formNameInput.val('');
            $modal.modal('hide');
            await window.openAlert(message, 'success');
            window.open(data.redirect, '_blank');
        } else {
            window.openAlert(message, 'error');
            const errorDisplay = $modal.find('.form-name-error');
            errorDisplay.removeClass('hidden').html(errors[0]);
        }
        spinner.remove();
    } catch (e) {
        window.openAlert(window.getCommonError(), 'error');
    }
});


$(document).mouseup(function (e) {
    let container = $(".community-item-menu>button, .community-item-menu a, .community-item-menu button");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(".community-item-menu button").removeClass('active');

    }
});

$(document).on('click', '.community-item-menu>button', function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
});

$(document).on('click', '.community-item-menu li>button', function (e) {
    e.preventDefault();
    $('.community-item-menu li>button').removeClass('active');
    $(this).addClass('active');
});
